export default {
  titlePrefix: '',
  UnifiTitle: 'Unifi',
  AcuraTitle: 'Acura',
  HondaTitle: 'Honda',
  HyundaiTitle: 'Hyundai',
  GenesisTitle: 'Genesis',
  ErrorTitle: 'Technical error',
  ErrorMessage: 'An error has occured. We apologize for the inconvenience.',
  ErrorRetryButton: 'Retry',
  NotFoundTitle: 'Page not found',
  NotFoundMessage: 'Sorry, the page may have been moved or deleted.',
  NotFoundBackButton: 'Back',
  CopyrightUnifi: '™ {{year}} iA Financial Group is a business name and trademark of Industrial Alliance Insurance and Financial Services Inc. All rights reserved.',
  CopyrightHyundai: '© {{year}} Hyundai Canada\nThe Hyundai name, logos, product names, feature names, images and slogans are trademarks owned or licensed by Hyundai Auto Canada Corp.',
  CopyrightGenesis: '™ / ® {{year}} The Genesis names, logos, product names, feature names, images and slogans are trademarks owned or licensed by Genesis Motors Canada, a division of Hyundai Auto Canada Corp.',
  CopyrightHonda: '© {{year}} Honda is a registered trademark of Honda Motor Co., Ltd. under license to Honda Canada Inc. All rights reserved.',
  CopyrightAcura: '© {{year}} Acura is a registered trademark of Honda Motor Co., Ltd. under license to Honda Canada Inc. All rights reserved.',
};
